import {
  SET_ALL_DATA_OF_ADMIN_STAFF,
  SET_FILTERED_ADMIN_STAFF,
  RESET_ALL_ADMIN_STAFF_DATA,
  SET_STAFF_ADMIN_STAFF,
  SET_PAGES_DATA_ADMIN_STAFF,
  SET_SHOULD_REFRESH_ADMIN_STAFF
} from "../../../action/admin/staff/type";

const initialState = {
  page: 0,
  total: 0,
  pages: 0,
  staff: [],
  filtered: [],
  loaded: false, // برای چک کردن اینکه آیا داده‌ها بارگذاری شده‌اند یا نه
  shouldRefresh: false, // 🔥 اضافه شد
};

const adminStaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_DATA_OF_ADMIN_STAFF:
      return {
        ...state,
        page: action.payload?.page,
        total: action.payload?.total,
        pages: action.payload?.pages,
        staff: action.payload?.staff,
        filtered: action.payload?.staff,
        loaded: true,
      };

    case SET_STAFF_ADMIN_STAFF:
      return {
        ...state,
        staff: action?.payload,
      };

    case SET_FILTERED_ADMIN_STAFF:
      return {
        ...state,
        filtered: action.payload,
      };

    case SET_PAGES_DATA_ADMIN_STAFF:
      return {
        ...state,
        page: action?.payload?.page,
        pages: action?.payload?.pages,
        total: action?.payload?.total,
      };

    case SET_SHOULD_REFRESH_ADMIN_STAFF: // 🔥 اضافه شد
      return {
        ...state,
        shouldRefresh: action.payload,
      };

    case RESET_ALL_ADMIN_STAFF_DATA:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};

export default adminStaffReducer;